import "./index.css";
import AppRoutes from "routes";
import { ReactModals } from "components/Modal/Notification/NotificationModal";

export default function App() {
  return (
    <>
      <ReactModals></ReactModals>
      <AppRoutes />
    </>
  );
}
